import axios, { AxiosError } from "axios";
import { API_URL, GetDemographicResult, LoginResult, VerifyInfo, VerifyResult} from "../constant";

export async function api_verify(info: VerifyInfo): Promise<VerifyResult> {

    try {
        const config = {
            validateStatus: (status: number) => {
                return status >= 200 && status < 500
            }
        };
        const response = await axios.post(
          `${API_URL}api/user/verifyinfo`,
          info,
          config
        );
    
        if (response.status === 200)
        {
            console.log(response.status)
            return { bSuccess: response.data.bSuccess, msg: response.data.msg};
        }
        else if (response.status === 429)
        {
            const detail = response.data?.detail ?? "Please wait before trying again.";
            const matched = String(detail).match(/(\d+)/);
            const waitSeconds = matched ? Number(matched[1]) : undefined;
            return { bSuccess: false, msg: detail, waitSeconds };
        }
        else if (response.status === 401)
        {
            return { bSuccess: false, msg: response.data?.detail ?? "Wrong Input! Please call our office..." };
        }
        else{
            return { bSuccess: false, msg: "Unexpected status code" };
        }
    } catch (err) {
        return { bSuccess: false, msg: "Unexpected status code" };
    }
}

export async function api_register(username: string, password: string, session: string): Promise<VerifyResult> {

    try {
        const config = {
            validateStatus: (status: number) => {
                return status >= 200 && status < 500
            }
        };
        const params = {username: username, password: password, session: session}
        const response = await axios.post(
          `${API_URL}api/user/register`,
          params,
          config
        );
    
        if (response.status === 204)
        {
            return { bSuccess: true, msg: 'Success to register user'};
        }
        else if (response.status === 401)
        {
            return { bSuccess: false, msg: 'Session expired or invalid. Please verify again.'};
        }
        else if (response.status === 403)
        {
            return { bSuccess: false, msg: 'This username is already in use. Please choose another one.'};
        }
        else{
            return { bSuccess: false, msg: "Unexpected status code" };
        }
    } catch (err) {
        return { bSuccess: false, msg: "Unexpected status code" };
    }
}

export async function api_verifyemail(token: string): Promise<VerifyResult> {
    try {
        const response = await axios.get(`${API_URL}api/user/verifyemail`, {
            params: {
                token,
            },
        });

        return {
            bSuccess: response.data.bSuccess,
            msg: response.data.msg,
        };
    } catch (error: any) {
        return {
            bSuccess: false,
            msg: error.response?.data?.msg ?? "Failed to verify email.",
        };
    }
}
  
export async function api_login(username : string, password: string): Promise<LoginResult> {

    try {
        localStorage.clear()
        const formData = new URLSearchParams();
        formData.append("username", username );
        formData.append("password", password);
        
        const response = await axios.post(
          `${API_URL}api/user/login`,
          formData,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            validateStatus: (status) => {
                return status >= 200 && status < 500;
            },
          }
        );
    
        if (response.status === 200)
        {
            localStorage.setItem("token", response.data.access_token);
            localStorage.setItem("username", response.data.username);
            localStorage.setItem("fileid", response.data.fileid)
            return { success: true, ...response.data };
        }
        else if (response.status === 401)
        {
            return { success: false, errorMsg: response.data?.detail ?? "Invalid username or password" };
        }
        else if (response.status === 429)
        {
            return { success: false, errorMsg: response.data?.detail ?? "Too many failed attempts. Please try again later." };
        }
        else
        {
            return { success: false, errorMsg: response.data?.detail ?? "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, errorMsg: `Server Error: ${error.response.status}` };
        } else if (error.request) {
            return { success: false, errorMsg: "No response received from server" };
        } else {
            return { success: false, errorMsg: `Error: ${error.message}` };
        }
    }
}

export async function api_getDemographic(fileid: number): Promise<GetDemographicResult>  {
    const token = localStorage.getItem("token")
        
    const config = {
        headers: {
          Authorization: `Bearer ${token}`, // Bearer token
        },
      };

    try {
        const response = await axios.get(
            `${API_URL}api/user/getDemographic`,
            {
              params: { fileid : fileid  },
              ...config
            },
          );
    
        if (response.status === 200)
        {
            return { success: true, demographic: response.data};
        }
        else if (response.status === 422)
        {
            return { success: false, errorMsg: "Validation Error" };
        }
        else{
            return { success: false, errorMsg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, errorMsg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, errorMsg: "No response received from server" };
        } else {
            return { success: false, errorMsg: `Error:, ${error.message}` };
        }
    }
}